import { render } from "./PageActiveAccount.vue?vue&type=template&id=56beb9e5"
import script from "./PageActiveAccount.vue?vue&type=script&lang=js"
export * from "./PageActiveAccount.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\WEB-SITE-DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__